import io from "socket.io-client";

const BackendURL = window.BackendURLCmk;
export const socket = io(`https://${BackendURL}:5004`);
